export default __webpack_public_path__ + "static/media/BGL_logo.54a8de53.png";